import CaseList from '@/views/case/CaseList.vue'

export default [
    {
        // 附近门店列表
        path: '/case/list',
        name: 'CaseList',
        component: CaseList
    },
    {
        // 附近门店详情
        path: '/case/detail/:id',
        name: 'CaseDetail',
        component: () => import('@/views/case/CaseDetail')
    }
]
